import { TextField } from '@chronosphereio/chrono-ui';
import { useCallback } from 'react';
import { NodeGraphStepOption, NodeGraphThresholdOptions } from '@/core';
import {
  ThresholdsEditor,
  ThresholdsEditorProps,
} from '@/plugin-editor-components/components/ThresholdsEditor/NewThresholdsEditor';

export const NodeGraphThresholdsEditor = ({
  thresholds,
  onChange,
}: {
  thresholds?: NodeGraphThresholdOptions;
  onChange: (newThresholds: NodeGraphThresholdOptions) => void;
}) => {
  const props: ThresholdsEditorProps<NodeGraphStepOption, NodeGraphThresholdOptions> = {
    onChange,
    renderStepOptions: ({ step, onStepChange }) => (
      <NodeGraphThresholdStepEditor step={step} onStepChange={onStepChange} />
    ),
    thresholds,
    hideThresholdMode: true,
  };

  return <ThresholdsEditor {...props} />;
};

function NodeGraphThresholdStepEditor<T extends Omit<NodeGraphStepOption, 'value'>>({
  step,
  onStepChange,
}: {
  step: T;
  onStepChange: (newStep: T) => void;
}) {
  const handleNameChange = useCallback(
    (newName: string) => {
      onStepChange({ ...step, name: newName });
    },
    [step, onStepChange]
  );

  return (
    <TextField
      inputProps={{ 'aria-label': 'enter threshold step label' }}
      defaultValue={step.name ?? ''}
      label="Label"
      fullWidth
      onBlur={(event) => handleNameChange(event.currentTarget.value)}
    />
  );
}
